module.exports = __webpack_public_path__ + "media/laws-bg2-1920@3x.f0985482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2-1920@3x.jpg
// module id = 1352
// module chunks = 57